/**
 * Owner: Masa Bayu
 * File: page.tsx
 * Date:Time: 2026-10-05 10:40
 * Description: Fasa 7 PoC · Page 19 dropcap justify live Face vs SoT raster.
 *
 * Note: mounted by RoutePanel at /p19-dropcap.
 */

import type { ReactElement } from 'react';
import { QxEditorPageFaceSpsu } from '../../profile/qx-editor-page-face';
import type { SPSUPage, TextElement } from '../../profile/spsu-types';
import '../p02/p02-live.css';

const SOURCE_PNG = '/evidence/pkt-ladder/sot-p19-pdfkit-dropcap-fullwidth.png';

function text(
  id: string,
  content: string,
  bbox: { x: number; y: number; width: number; height: number },
  fontSize: number,
): TextElement {
  return {
    id,
    type: 'text',
    bbox: { ...bbox, unit: 'pt' },
    layer: 1,
    content,
    style: {
      fontFamily: 'Calibri',
      fontSize,
      fontWeight: 'normal',
      fontStyle: 'normal',
      color: '#000000',
      textAlign: 'left',
    },
  };
}

/** Forensic Page 19 dropcap band + absolute sebagai (must stay untouched). */
function buildPage19DropcapSpsu(): SPSUPage {
  const elements: TextElement[] = [
    text('el_p19_line_5', '3.0 PENDAHULUAN', { x: 85.1, y: 268.76, width: 113, height: 12 }, 12),
    text('el_p19_line_7', 'M', { x: 85.1, y: 293.26, width: 29.84, height: 34.5 }, 34.5),
    text(
      'el_p19_line_6',
      'enjelang penghujung pemerintahan Sulaiman bin',
      { x: 114.92, y: 297.5, width: 219.28, height: 10.98 },
      10.98,
    ),
    text(
      'el_p19_line_8',
      'Abdul Malik, Kerajaan Bani Umayyah masih muncul',
      { x: 114.92, y: 316.78, width: 229.11, height: 10.98 },
      10.98,
    ),
    text(
      'el_p19_line_9',
      'sebagai kuasa terbesar di dunia Islam. Wilayahnya',
      { x: 85.1, y: 333.78, width: 273.6, height: 10.98 },
      10.98,
    ),
    text(
      'el_p19_line_10',
      'terbentang luas dari Andalus di barat hingga ke sempadan',
      { x: 85.1, y: 350.78, width: 273.6, height: 10.98 },
      10.98,
    ),
  ];
  return {
    id: 'page_p19_dropcap_poc',
    pageNumber: 19,
    size: { width: 453.6, height: 674.76, unit: 'pt' },
    elements,
    readingOrder: elements.map((el) => el.id),
  };
}

/**
 * Live PoC: SoT crop (left) · Face with Fasa 7 Core Engine justify (right).
 */
export default function P19DropcapJustifyLivePage(): ReactElement {
  const page = buildPage19DropcapSpsu();
  const textCount = page.elements.filter((el) => el.type === 'text').length;

  return (
    <div className="p02-live" data-p19-dropcap-poc="">
      <header className="p02-live-header">
        <p className="p02-live-kicker">p19-dropcap</p>
        <h1>Fasa 7 · Dropcap Justify Live PoC</h1>
        <p>
          Kiri: SoT PDF crop · Kanan: Face + Core Engine (`data-native-dropcap-justified`) · {textCount}{' '}
          teks · sebagai/terbentang kekal absolute
        </p>
      </header>
      <div className="p02-live-grid">
        <section className="p02-live-pane">
          <h2>Sumber · SoT dropcap crop</h2>
          <img src={SOURCE_PNG} alt="SoT Page 19 dropcap crop" />
        </section>
        <section className="p02-live-pane">
          <h2>Live Face · Fasa 7 inject</h2>
          <div className="p02-live-face-host">
            <QxEditorPageFaceSpsu page={page} assets={{}} editable={false} fit />
          </div>
        </section>
      </div>
    </div>
  );
}
